// components/ToastManager.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/layout/alertComponent/Toast';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

const ToastManager = ({ children, defaultPosition = 'bottomRight', defaultBackgroundColor = 'red' }) => {

    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((message, type, position, backgroundColor, buttonText, buttonAction) => {
        const id = Date.now();
        setToasts(prevToasts => [...prevToasts, { id, message, type, position: position || defaultPosition, backgroundColor: backgroundColor || defaultBackgroundColor, buttonText, buttonAction }]);
        setTimeout(() => removeToast(id), 3000); // Remove toast after 3 seconds
    }, [defaultPosition, defaultBackgroundColor]);

    const removeToast = useCallback((id) => {
        setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
    }, []);




    return (
        <ToastContext.Provider value={addToast}>
            {children}
            {toasts.map(toast => (
                <Toast
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                    position={toast.position}
                    backgroundColor={toast.backgroundColor}
                    buttonText={toast.buttonText}
                    buttonAction={toast.buttonAction}
                />
            ))}
        </ToastContext.Provider>
    );
};

export default ToastManager;